import React, { Component } from "react";
import ToolBar from "./toolbar";
import { BookStore } from "../../gadgets/flux";

let lastRate = 0.5;
let lastVoice = 0;
let lastAlt = false;

export default class ToolBarWithApi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
      paused: false,
      voices: [],
      rate: lastRate,
      voice: lastVoice,
      altEnabled: lastAlt,
      ttsAvailable: false
    };
    this.book = BookStore.get(this.props.isbn);
  }

  componentDidMount() {
    this.book.viewer.bind("tts-v2:status", this.getSpeechStatus);
    this.book.viewer.TTS.setNoContentMessage(i18n.t("tts.no-content"));
    this.book.viewer.TTS.getVoices(voices => {
      this.setState({
        voices
      });
    });
    this.book.viewer.TTS.changeRate(lastRate);
    this.book.viewer.TTS.setVoice(lastVoice);
    if (lastAlt) {
      this.book.viewer.TTS.enableAltText();
    } else {
      this.book.viewer.TTS.disableAltText();
    }
    this.book.viewer.TTS.sendStatus();
  }

  componentWillUnmount() {
    lastRate = this.state.rate;
    lastVoice = this.state.voice;
    lastAlt = this.state.altEnabled;

    this.book.viewer.TTS.cancel();
    this.book.viewer.unbind("tts-v2:status", this.getSpeechStatus);
  }

  getSpeechStatus = (e, data) => {
    this.setState({
      isPlaying: data.playing,
      paused: data.paused,
      rate: data.rate,
      voice: data.voice,
      altEnabled: data.altEnabled,
      ttsAvailable: data.isSupported,
      isReady: data.isReady,
      canNav: data.canNav
    });
  };

  onPlay = () => {
    if (!this.state.paused && !this.state.isPlaying) {
      this.book.viewer.TTS.startFromTop();
      Fraction.Reporter.gaEvent("V3-TTS/startFromTop");
    } else {
      this.book.viewer.TTS.resume();
      Fraction.Reporter.gaEvent("V3-TTS/resume");
    }
  };

  onClose = () => {
    this.book.viewer.TTS.cancel();
    this.props.onClose();
    Fraction.Reporter.gaEvent("V3-TTS/stopAndClose");
  };

  skipForward = () => {
    this.book.viewer.TTS.skipForward();
    Fraction.Reporter.gaEvent("V3-TTS/skipForward");
  };

  skipBack = () => {
    this.book.viewer.TTS.skipBack();
    Fraction.Reporter.gaEvent("V3-TTS/skipBack");
  };

  pause = () => {
    this.book.viewer.TTS.pause();
    Fraction.Reporter.gaEvent("V3-TTS/pause");
  };

  setVoice = (...args) => {
    this.book.viewer.TTS.setVoice(...args);
    Fraction.Reporter.gaEvent("V3-TTS/setVoice");
  };

  enableAltText = () => {
    this.book.viewer.TTS.enableAltText();
    Fraction.Reporter.gaEvent("V3-TTS/enableAltText");
  };

  disableAltText = () => {
    this.book.viewer.TTS.disableAltText();
    Fraction.Reporter.gaEvent("V3-TTS/disableAltText");
  };

  changeRate = value => {
    this.book.viewer.TTS.changeRate(value);
    Fraction.Reporter.gaEvent("V3-TTS/changeRate");
  };

  render() {
    const { ttsAvailable, isPlaying, paused } = this.state;

    if (ttsAvailable) {
      return (
        <ToolBar
          onClose={this.onClose}
          onPlay={this.onPlay}
          onSkipBack={this.skipBack}
          onSkipForward={this.skipForward}
          onPause={this.pause}
          isPlaying={isPlaying && !paused}
          changeRate={this.changeRate}
          setVoice={this.setVoice}
          enableAltText={this.enableAltText}
          disableAltText={this.disableAltText}
          voices={this.state.voices}
          currentRate={this.state.rate}
          currentVoice={this.state.voice}
          altEnabled={this.state.altEnabled}
          isReady={this.state.isReady}
          canNav={this.state.canNav}
        />
      );
    }
    return null;
  }
}
